import { render, staticRenderFns } from "./OurProducts.vue?vue&type=template&id=7d2ad118&scoped=true"
import script from "./OurProducts.vue?vue&type=script&lang=js"
export * from "./OurProducts.vue?vue&type=script&lang=js"
import style0 from "./OurProducts.vue?vue&type=style&index=0&id=7d2ad118&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2ad118",
  null
  
)

export default component.exports